import * as React from "react";
import * as Yup from "yup";

import { Navigate, useLocation } from "react-router-dom";

import Button from "@mui/joy/Button";
import CircularProgress from "@mui/joy/CircularProgress";
import { ExclamationIcon } from "components/ui/icons";
import FormControl from "@mui/joy/FormControl";
import FormHelperText from "@mui/joy/FormHelperText";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import { LoginFormFields } from "./loginForm.types";
import Snackbar from "@mui/joy/Snackbar";
import { useAuth } from "context/AuthProvider";
import { useFormik } from "formik";
import { useLoginForm } from "./loginForm.hooks";

type Props = {
  authToken: string | undefined;
};
function LoginForm(props: Props) {
  const { authToken } = props;
  const { loading, handleLogin, openAlert, handleCloseAlert, alertMessage } = useLoginForm(authToken);
  const { authUser } = useAuth();

  const initialValues: LoginFormFields = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Email incorect").required("Obligatoriu"),
    password: Yup.string().required("Obligatoriu"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleLogin(values);
      formik.setSubmitting(false);
    },
  });

  const location = useLocation();
  //
  // const redirectUrl = location.state && location.state.from ? location.state.from.pathname : '/';
  const redirectUrl = location?.search?.slice(6) || "/";

  return (
    <>
      {authUser !== null && <Navigate to={redirectUrl}></Navigate>}
      <form className="flex flex-col max-w-sm gap-4 mx-auto mb-8" autoComplete="off" onSubmit={formik.handleSubmit}>
        <FormControl error={true}>
          <FormLabel>Email</FormLabel>
          <Input
            name="email"
            type="text"
            placeholder="Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.email ? true : false}
            required
            fullWidth
          />
          <FormHelperText>{formik.errors?.email}</FormHelperText>
        </FormControl>

        <FormControl error={true}>
          <FormLabel>Password</FormLabel>
          <Input
            name="password"
            type="password"
            placeholder="Parolă"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.password ? true : false}
            required
            fullWidth
          />
          <FormHelperText>{formik.errors?.password}</FormHelperText>
        </FormControl>

        <div className="w-full ml-auto">
          <Button id="submit" type="submit" variant="solid" disabled={loading} fullWidth>
            Autentificare
            {loading && <CircularProgress variant="plain" sx={{ position: "absolute" }} />}
          </Button>
        </div>
      </form>

      <Snackbar
        variant="solid"
        color={alertMessage.color}
        open={openAlert}
        onClose={handleCloseAlert}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        startDecorator={<ExclamationIcon />}
      >
        {alertMessage.message}
      </Snackbar>
    </>
  );
}

export { LoginForm };
